import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoTreatment} from "./models/DtoTreatment";
import {DtoTreatmentBaseItems} from "./models/DtoTreatmentBaseItems";
import {PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {TreatmentCombinationSearchComponent} from "./treatment-combination-search.component";
import {DtoTreatmentForCombi} from "./models/DtoTreatmentForCombi";
import {DtoTreatmentCombination} from "./models/DtoTreatmentCombination";
import {ArticleCombinationSearchComponent} from "./article-combination-search.component";
import {DtoArticleForCombi} from "./models/DtoArticleForCombi";
import {DtoArticleCombination} from "./models/DtoArticleCombination";

@Component({
    selector: 'treatment-combination',
    template: require('./treatment-combination.component.html'),
    styles: [require('./treatment-combination.component.css')]
})
@AutoUnsubscribe()

export class TreatmentCombinationComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridPriceMutation', {static: false}) gridPriceMutation: DynamicGridComponent;
    @ViewChild('gridCombiTreatments', {static: false}) gridCombiTreatments: DynamicGridComponent;
    @ViewChild('gridCombiArticles', {static: false}) gridCombiArticles: DynamicGridComponent;
    form: FormGroup;
    dtoObject: DtoTreatment;
    baseItems: DtoTreatmentBaseItems;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    priceMutationColumnDefinition: ColumnDefinition[] = [
        {
            key: 'mutationDate',
            label: 'Ingangsdatum',
            type: 'date',
            width: '150px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'btwDescription',
            label: 'BTW %',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPriceEx',
            label: 'Verkoopprijs excl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        },
        {
            key: 'retailPrice',
            label: 'Verkoopprijs incl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        }
    ];
    combiTreatmentConfig: PageSubheaderBarConfig = {
        title: 'BEHANDELINGEN',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'WIJZIGEN',
                isSmall: true,
                clickEventType: 'edit'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    combiTreatmentColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Volgnummer',
            type: 'string',
            width: '140px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'treatmentTime',
            label: 'Behandeltijd',
            type: 'string',
            width: '140px'
        },
        {
            key: 'retailPrice',
            label: 'Behandelprijs',
            type: 'number',
            width: '140px',
            format: '{0:c}'
        }
    ];
    combiArticleConfig: PageSubheaderBarConfig = {
        title: 'ARTIKELEN',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'WIJZIGEN',
                isSmall: true,
                clickEventType: 'edit'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    combiArticleColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Volgnummer',
            type: 'string',
            width: '140px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPrice',
            label: 'Artikelprijs',
            type: 'number',
            width: '140px',
            format: '{0:c}'
        }
    ];
    hasPriceChange: boolean;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService,
                private dialogService: DialogService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired]],
            isActive: null,
            departmentId: [null, [SharedValidators.customRequired]],
            treatmentSalesgroupId: null,
            treatmentSubSalesgroupId: null,
            cashregGroupId: null,
            cashregSubGroupId: null,
            employeeAdvice: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getTreatmentById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                    this.gridPriceMutation.showData(this.dtoObject.treatmentPriceMutations);
                    this.gridCombiTreatments.showData(this.dtoObject.treatmentCombinations);
                    this.gridCombiArticles.showData(this.dtoObject.articleCombinations);
                });
        }
        else {
            this.ds.getTreatmentNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        retailPrice: 0,
                        retailPriceEx: 0,
                        variablePrice: true,
                        treatmentPriceMutations: [],
                        articleCombinations: [],
                        minuteRetailPrice: 0,
                        treatmentCombinations: [],
                        treatmentTime: 0,
                        treatmentKindId: 1
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getTreatmentById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.treatmentTime = response.treatmentTime;
                                this.dtoObject.minuteRetailPrice = response.minuteRetailPrice;
                                this.dtoObject.btwGroupId = response.btwGroupId;
                                this.dtoObject.cashregGroupId = response.cashregGroupId;
                                this.dtoObject.cashregSubGroupId = response.cashregSubGroupId;
                                this.dtoObject.customerAdvice = response.customerAdvice;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.dtoObject.grootboekNumber = response.grootboekNumber;
                                this.dtoObject.retailPriceEx = response.retailPriceEx;
                                this.dtoObject.retailPrice = response.retailPrice;
                                this.dtoObject.treatmentSalesgroupId = response.treatmentSalesgroupId;
                                this.dtoObject.treatmentSubSalesgroupId = response.treatmentSubSalesgroupId;
                                this.dtoObject.treatmentType = response.treatmentType;
                                this.dtoObject.variablePrice = response.variablePrice;

                                for(let i = 0; i < response.articleCombinations.length; i++) {
                                    this.dtoObject.articleCombinations.push({
                                        id: 0,
                                        retailPrice: response.articleCombinations[i].retailPrice,
                                        retailPriceEx: response.articleCombinations[i].retailPriceEx,
                                        index: response.articleCombinations[i].index,
                                        articleId: response.articleCombinations[i].articleId,
                                        description: response.articleCombinations[i].description
                                    });
                                }

                                for(let i = 0; i < response.treatmentCombinations.length; i++) {
                                    this.dtoObject.treatmentCombinations.push({
                                        id: 0,
                                        retailPrice: response.treatmentCombinations[i].retailPrice,
                                        retailPriceEx: response.treatmentCombinations[i].retailPriceEx,
                                        index: response.treatmentCombinations[i].index,
                                        treatmentTime: response.treatmentCombinations[i].treatmentTime,
                                        combinationTreatmentId: response.treatmentCombinations[i].combinationTreatmentId,
                                        description: response.treatmentCombinations[i].description
                                    });
                                }

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                                this.gridCombiTreatments.showData(this.dtoObject.treatmentCombinations);
                                this.gridCombiArticles.showData(this.dtoObject.articleCombinations);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getTreatmentBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
                let btwZero = this.baseItems.btwGroups.find(x => x.percentage == 0);
                if (btwZero) {
                    this.dtoObject.btwGroupId = btwZero.id;
                } else {
                    this.ss.message('Er is geen BTW 0% gevonden. Deze BTW groep is nodig om een combinatiebehandeling aan te maken.');
                    this.closeWindow(false);
                }
            }
        });
    }

    getSubSalesgroups() {
        if (this.baseItems && this.form.get('treatmentSalesgroupId').value) {
            return this.baseItems.salesgroups.find(x => x.id == this.form.get('treatmentSalesgroupId').value).treatmentSubSalesgroups;
        }
        return null;
    }

    getCashregSubGroups() {
        if (this.baseItems && this.form.get('cashregGroupId').value) {
            return this.baseItems.cashregGroups.find(x => x.id == this.form.get('cashregGroupId').value).cashregSubGroups;
        }
        return null;
    }

    checkForPriceChange() {
        if (this.dtoObject.treatmentPriceMutations.length > 0) {
            let lastPrice = this.dtoObject.treatmentPriceMutations[0];
            this.hasPriceChange = ((lastPrice.btwGroupId != this.dtoObject.btwGroupId)
                || (lastPrice.retailPrice != this.dtoObject.retailPrice)
                || (lastPrice.retailPriceEx != this.dtoObject.retailPriceEx));
        }

        if (this.dtoObject.treatmentPriceMutations.length == 0 || this.hasPriceChange) {
            this.dtoObject.treatmentPriceMutations.push({
                id: 0,
                retailPriceEx: this.dtoObject.retailPriceEx,
                retailPrice: this.dtoObject.retailPrice,
                btwGroupId: this.dtoObject.btwGroupId,
                mutationDate: new Date(Date.now())
            });
        }
    }

    validateCombiTreatments() {
        if (this.dtoObject.treatmentCombinations.length == 0 && this.dtoObject.articleCombinations.length == 0) {
            this.ss.message('Een combinatiebehandeling moet minimaal 1 onderdeel bevatten');
            return false;
        }
        return true;
    }

    btnCombiTreatmentBarClicked(event) {
        if (event == 'create') {
            this.showTreatmentCombiSearchWindow(null);
        } else if (event == 'edit' && this.gridCombiTreatments.getSelectedItem()) {
            this.showTreatmentCombiSearchWindow(this.gridCombiTreatments.getSelectedItem());
        } else if (event == 'delete' && this.gridCombiTreatments.getSelectedItem()) {
            this.dtoObject.treatmentCombinations.splice(this.dtoObject.treatmentCombinations.indexOf(this.gridCombiTreatments.getSelectedItem()), 1);
            let indexCounter = 1;
            this.dtoObject.treatmentCombinations.forEach((item) => {
                item.index = indexCounter;
                indexCounter++;
            });
            this.gridCombiTreatments.showData(this.dtoObject.treatmentCombinations);
            this.calculateTotalPrice();
        }
    }

    showTreatmentCombiSearchWindow(currentObject: DtoTreatmentCombination) {
        const dialogRef = this.dialogService.open({
            content: TreatmentCombinationSearchComponent
        });

        const dialogContent: TreatmentCombinationSearchComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.objectToEdit = currentObject;

        dialogContent.treatmentChosen.subscribe((res: DtoTreatmentForCombi) => {
            if (res.index > 0) {
                let currentIndex = this.dtoObject.treatmentCombinations.findIndex(x => x.index == res.index);
                if (this.dtoObject.treatmentCombinations[currentIndex]) {
                    this.dtoObject.treatmentCombinations[currentIndex] = {
                        id: res.id,
                        index: res.index,
                        description: res.description,
                        retailPrice: res.retailPrice,
                        combinationTreatmentId: res.id,
                        treatmentTime: res.treatmentTime,
                        retailPriceEx: res.retailPriceEx
                    };
                }
            } else {
                let newIndex = 1;
                if (this.dtoObject.treatmentCombinations.length > 0)
                    newIndex = Math.max.apply(Math, this.dtoObject.treatmentCombinations.map(function (o) {
                        return o.index;
                    })) + 1;
                this.dtoObject.treatmentCombinations.push({
                    id: 0,
                    index: newIndex,
                    description: res.description,
                    retailPrice: res.retailPrice,
                    combinationTreatmentId: res.id,
                    treatmentTime: res.treatmentTime,
                    retailPriceEx: res.retailPriceEx
                });
            }
            this.gridCombiTreatments.showData(this.dtoObject.treatmentCombinations);
            this.calculateTotalPrice();
        });
    }

    combiTreatmentRowDoubleClick(event) {
        if (this.gridCombiTreatments.getSelectedItem()) {
            this.showTreatmentCombiSearchWindow(this.gridCombiTreatments.getSelectedItem());
        }
    }

    btnCombiArticleBarClicked(event) {
        if (event == 'create') {
            this.showArticleCombiSearchWindow(null);
        } else if (event == 'edit' && this.gridCombiArticles.getSelectedItem()) {
            this.showArticleCombiSearchWindow(this.gridCombiArticles.getSelectedItem());
        } else if (event == 'delete' && this.gridCombiArticles.getSelectedItem()) {
            this.dtoObject.articleCombinations.splice(this.dtoObject.articleCombinations.indexOf(this.gridCombiArticles.getSelectedItem()), 1);
            let indexCounter = 1;
            this.dtoObject.articleCombinations.forEach((item) => {
                item.index = indexCounter;
                indexCounter++;
            });
            this.gridCombiArticles.showData(this.dtoObject.articleCombinations);
            this.calculateTotalPrice();
        }
    }

    showArticleCombiSearchWindow(currentObject: DtoArticleCombination) {
        const dialogRef = this.dialogService.open({
            content: ArticleCombinationSearchComponent
        });

        const dialogContent: ArticleCombinationSearchComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.objectToEdit = currentObject;

        dialogContent.articleChosen.subscribe((res: DtoArticleForCombi) => {
            if (res.index > 0) {
                let currentIndex = this.dtoObject.articleCombinations.findIndex(x => x.index == res.index);
                if (this.dtoObject.articleCombinations[currentIndex]) {
                    this.dtoObject.articleCombinations[currentIndex] = {
                        id: res.id,
                        index: res.index,
                        description: res.description,
                        retailPrice: res.retailPrice,
                        articleId: res.id,
                        retailPriceEx: res.retailPriceEx
                    };
                }
            } else {
                let newIndex = 1;
                if (this.dtoObject.articleCombinations.length > 0)
                    newIndex = Math.max.apply(Math, this.dtoObject.articleCombinations.map(function (o) {
                        return o.index;
                    })) + 1;
                this.dtoObject.articleCombinations.push({
                    id: 0,
                    index: newIndex,
                    description: res.description,
                    retailPrice: res.retailPrice,
                    articleId: res.id,
                    retailPriceEx: res.retailPriceEx
                });
            }
            this.gridCombiArticles.showData(this.dtoObject.articleCombinations);
            this.calculateTotalPrice();
        });
    }

    combiArticleRowDoubleClick(event) {
        if (this.gridCombiArticles.getSelectedItem()) {
            this.showArticleCombiSearchWindow(this.gridCombiArticles.getSelectedItem());
        }
    }

    calculateTotalPrice() {
        this.dtoObject.retailPriceEx = 0;
        this.dtoObject.retailPrice = 0;
        this.dtoObject.treatmentTime = 0;

        this.dtoObject.treatmentCombinations.forEach((item) => {
            this.dtoObject.retailPrice += item.retailPrice;
            this.dtoObject.retailPriceEx += item.retailPriceEx;
            this.dtoObject.treatmentTime += item.treatmentTime;
        });
        if (this.dtoObject.treatmentTime > 0) {
            this.dtoObject.minuteRetailPrice = this.ss.round(this.dtoObject.retailPrice / this.dtoObject.treatmentTime, 2);
        } else {
            this.dtoObject.minuteRetailPrice = 0;
        }

        this.dtoObject.articleCombinations.forEach((item) => {
            this.dtoObject.retailPrice += item.retailPrice;
            this.dtoObject.retailPriceEx += item.retailPriceEx;
        });

        this.dtoObject.retailPrice = this.ss.round(this.dtoObject.retailPrice, 2);
        this.dtoObject.retailPriceEx = this.ss.round(this.dtoObject.retailPriceEx, 2);
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid && this.validateCombiTreatments()) {
            this.checkForPriceChange();
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            if (this.hasPriceChange && this.dtoObject.id > 0) {
                this.ds.treatmentHasFuturePriceChange().subscribe(res => {
                   if (res) {
                       this.ss.message('U kunt geen prijzen wijzigen omdat u al een prijswijziging in de toekomst klaar heeft staan. ' +
                           'Wilt u nu toch prijzen wijzigen? Klik dan op Prijswijzigingen / Correctie Prijswijziging en verwijder de geagendeerde prijswijziging.');
                   } else {
                       this.saveTreatment(result);
                   }
                });
            } else {
                this.saveTreatment(result);
            }
        }
    }

    saveTreatment(result: DtoTreatment) {
        this.ds.saveTreatment(result)
            .subscribe(response => {
                if (!response.hasError) {
                    this.closeWindow(true);
                }
                else {
                    this.ss.message(response.errorMessage);
                }
            });
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/treatment-combination.component.ts